import React from "react"
import styled from 'styled-components' 

const LinkSVG = (props) => (
  <StyledLinkSVG x="0px" y="0px" viewBox="0 0 100 100" height={props.height} color={props.color}  >
      <g><path d="M67,55.7l9.2-9.2c2.1-2.1,3.2-4.8,3.2-7.8c0-2.9-1.1-5.7-3.2-7.8l-7.1-7.1c-2.1-2.1-4.8-3.2-7.8-3.2   c-2.9,0-5.7,1.1-7.8,3.2L44.3,33c-2.2,2.2-3.3,5.2-3.2,8.1c-2.9-0.1-5.9,1-8.1,3.2l-9.2,9.2c-2.1,2.1-3.2,4.8-3.2,7.8   c0,2.9,1.1,5.7,3.2,7.8l7.1,7.1c2.1,2.1,4.8,3.2,7.8,3.2c2.9,0,5.7-1.1,7.8-3.2l9.2-9.2c2.2-2.2,3.3-5.2,3.2-8.1c0.1,0,0.2,0,0.3,0   C62,58.9,64.8,57.8,67,55.7z M51.4,62.7l-9.2,9.2c-1.9,1.9-5.1,1.9-7.1,0l-7.1-7.1c-1.9-1.9-1.9-5.1,0-7.1l9.2-9.2   c1.9-1.9,5.1-1.9,7.1,0c0.5,0.5,1.2,0.8,2,0.9l-7.6,7.6c-1.2,1.2-1.2,3.1,0,4.2c0.6,0.6,1.4,0.9,2.1,0.9s1.5-0.3,2.1-0.9l7.6-7.6   c0,0.7,0.3,1.4,0.9,2C53.4,57.6,53.4,60.8,51.4,62.7z M53.7,50.6l8.6-8.6c1.2-1.2,1.2-3.1,0-4.2c-1.2-1.2-3.1-1.2-4.2,0l-8.6,8.6   c0-0.7-0.3-1.4-0.9-2c-1.9-2-1.9-5.1,0-7.1l9.2-9.2c1.9-1.9,5.1-1.9,7.1,0l7.1,7.1c1.9,1.9,1.9,5.1,0,7.1l-9.2,9.2   c-1.9,1.9-5.1,1.9-7.1,0C55.1,50.9,54.4,50.6,53.7,50.6z"></path></g>
  </StyledLinkSVG>
)

 
const StyledLinkSVG = styled.svg`
  fill: ${props => props.color}};
  height: ${props => props.height};
  @media (min-width: 450px) {
    height: ${props => props.aboveHeight}
  }
`

export default LinkSVG